<template>
  <div>
    <v-dialog persistent scrollable v-model="dialog" width="500">
      <v-btn
        small
        fab
        depressed
        v-if="newContact"
        slot="activator"
        color="theme_primary_lighten1 white--text"
      >
        <v-icon small flat>mdi-account-plus</v-icon>
      </v-btn>

      <v-btn
        depressed
        fab
        small
        v-if="showContact"
        slot="activator"
        flat
        color="theme_primary_lighten1"
      >
        <v-icon small flat>edit</v-icon>
      </v-btn>

      <v-card tile flat>
        <v-toolbar tile flat dense color="theme_primary" class="white--text">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white-text text-capitalize"
            >{{ contactType }} contact</v-toolbar-title
          >

          <v-spacer></v-spacer>
          <v-toolbar-side-icon>
            <v-icon color="white">mdi-account-edit</v-icon>
          </v-toolbar-side-icon>
        </v-toolbar>

        <v-card-text>
          <v-card flat class="mb-4 px-2">
            <v-subheader>
              <v-icon color="primary" small class="pr-2">person</v-icon>Identity
            </v-subheader>
            <v-layout row wrap>
              <v-flex xs6 pr-2>
                <v-text-field
                  v-model="currentCompanyContact.first_name"
                  required
                  label="First name"
                  background-color="white"
                  autocomplete="noautocomplete"
                />
              </v-flex>
              <v-flex xs6 pl-2>
                <v-text-field
                  v-model="currentCompanyContact.last_name"
                  required
                  label="Last name"
                  background-color="white"
                  autocomplete="noautocomplete"
                />
              </v-flex>
            </v-layout>
            <v-text-field
              v-model="currentCompanyContact.username"
              label="User name"
              background-color="white"
              autocomplete="noautocomplete"
            />
          </v-card>

          <v-card flat class="my-4 px-2">
            <v-subheader>
              <v-icon color="primary" small class="pr-2">phone</v-icon>Phone(s)
            </v-subheader>

            <v-flex xs12>
              <template v-for="(phone, index) in currentCompanyContact.phones">
                <v-layout align-center :key="index + '_phone'">
                  <v-text-field
                    :label="phone.key"
                    v-model="currentCompanyContact.phones[index].value"
                    background-color="white"
                    autocomplete="noautocomplete"
                    append-icon="delete"
                    @click:append="removeMedium('phones', index)"
                  />
                </v-layout>
              </template>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs6 pr-2>
                <v-autocomplete
                  v-model="newPhone.key"
                  item-value="name"
                  item-text="name"
                  :items="phoneSelect"
                  label="Label"
                  placeholder="Work"
                  background-color="white"
                  autocomplete="noautocomplete"
                />
              </v-flex>
              <v-flex xs6 pl-2>
                <v-text-field
                  v-model="newPhone.value"
                  label="Phone value"
                  placeholder="04 23 45 57 56 76"
                  background-color="white"
                  autocomplete="noautocomplete"
                  :append-icon="newPhone.key && newPhone.value ? 'add' : ''"
                  @click:append="
                    newPhone.key && newPhone.value
                      ? addThisPhone('currentCompanyContact')
                      : ''
                  "
                />
              </v-flex>
            </v-layout>
          </v-card>

          <v-card flat class="my-4 px-2">
            <v-subheader>
              <v-icon color="primary" small class="pr-2">email</v-icon>Email(s)
            </v-subheader>
            <v-flex xs12>
              <template v-for="(email, index) in currentCompanyContact.emails">
                <v-layout align-center :key="index + '_email'">
                  <v-text-field
                    :label="email.key"
                    v-model="currentCompanyContact.emails[index].value"
                    background-color="white"
                    autocomplete="noautocomplete"
                    append-icon="delete"
                    @click:append="removeMedium('emails', index)"
                  />
                </v-layout>
              </template>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs6 pr-2>
                <v-autocomplete
                  v-model="newEmail.key"
                  item-value="name"
                  item-text="name"
                  :items="emailSelect"
                  label="Label"
                  placeholder="Work"
                  background-color="white"
                  autocomplete="noautocomplete"
                />
              </v-flex>
              <v-flex xs6 pl-2>
                <v-text-field
                  v-model="newEmail.value"
                  autocomplete="noautocomplete"
                  :rules="[rules.emailRule]"
                  label="Email value"
                  placeholder="exemple@gmail.com"
                  background-color="white"
                  :append-icon="newEmail.key && newEmail.value ? 'add' : ''"
                  @click:append="
                    newEmail.key && newEmail.value
                      ? addThisEmail('currentCompanyContact')
                      : ''
                  "
                />
              </v-flex>
            </v-layout>
          </v-card>

          <v-card flat class="my-4 px-2">
            <v-subheader>
              <v-icon color="primary" small class="pr-2">mdi-skype</v-icon
              >Skype(s)
            </v-subheader>
            <v-flex xs12>
              <template v-for="(skype, index) in currentCompanyContact.skypes">
                <v-layout align-center :key="index + '_skype'">
                  <v-text-field
                    :label="skype.key"
                    v-model="currentCompanyContact.skypes[index].value"
                    background-color="white"
                    autocomplete="noautocomplete"
                    append-icon="delete"
                    @click:append="removeMedium('skypes', index)"
                  />
                </v-layout>
              </template>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs6 pr-2>
                <v-autocomplete
                  v-model="newSkype.key"
                  item-value="name"
                  item-text="name"
                  :items="skypeSelect"
                  label="Label"
                  placeholder="Work"
                  autocomplete="noautocomplete"
                  background-color="white"
                />
              </v-flex>
              <v-flex xs6 pl-2>
                <v-text-field
                  autocomplete="noautocomplete"
                  v-model="newSkype.value"
                  label="Skype value"
                  placeholder="skype.pseudo"
                  background-color="white"
                  :append-icon="newSkype.key && newSkype.value ? 'add' : ''"
                  @click:append="
                    newSkype.key && newSkype.value
                      ? addThisSkype('currentCompanyContact')
                      : ''
                  "
                />
              </v-flex>
            </v-layout>
          </v-card>
        </v-card-text>

        <v-flex px-4>
          <v-divider></v-divider>
        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat @click="dialog = false" color="error">
            <v-icon small class="pr-2">close</v-icon>Cancel
          </v-btn>
          <v-btn flat @click="save()" color="success">
            <v-icon small class="pr-2">save</v-icon>Save Commercial Contact
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mutationLoading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading... Please wait.
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CREATE_COMPANY_CONTACT from "../../graphql/company_contacts/create.gql";
import UPDATE_COMPANY_CONTACT from "../../graphql/company_contacts/update.gql";
import { mapGetters } from "vuex";

export default {
  props: {
    contactType: {
      type: String,
      required: true,
    },
    newContact: {
      type: Boolean,
    },
    showContact: {
      type: Boolean,
    },
    companyContactId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      mutationLoading: false,
      dialog: false,
      newPhone: {},
      newEmail: {},
      newSkype: {},

      rules: {
        required: (value) => {
          return !!value || "Required.";
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value);
        },
        emailRule: (value) => {
          if (!value) return true;
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid email.";
        },
      },

      phoneSelect: [
        { name: "Work" },
        { name: "Whatsapp" },
        { name: "Home" },
        { name: "Mobile" },
        { name: "Other" },
      ],
      emailSelect: [{ name: "Work" }, { name: "Home" }, { name: "Other" }],
      skypeSelect: [{ name: "Work" }, { name: "Home" }],

      firstNameRule: [(v) => !!v || "First name is required"],
      lastNameRule: [(v) => !!v || "Last name is required"],
      newCompanyContact: {
        first_name: "",
        last_name: "",
        username: "",
        phones: [],
        emails: [],
        skypes: [],
        company_contact_type: "",
        company_id: "",
      },
    };
  },
  methods: {
    resetMedium(type) {
      this[type] = {};
    },
    addThisPhone(contact) {
      this[contact].phones.push(this.newPhone);
      this.resetMedium("newPhone");
    },
    addThisEmail(contact) {
      this[contact].emails.push(this.newEmail);
      this.resetMedium("newEmail");
    },
    addThisSkype(contact) {
      this[contact].skypes.push(this.newSkype);
      this.resetMedium("newSkype");
    },
    removeMedium(type, index) {
      this.currentCompanyContact[type].splice(index, 1);
    },
    buttonTitle() {
      return this.companyContactId ? "Update" : "New";
    },
    save() {
      const contact = {
        ...this.currentCompanyContact,
        company_contact_type: this.contactType,
        company_id: this.newCompany.id,
      };
      if (this.companyContactId) this.update(contact);
      else this.create(contact);
    },
    update(contact) {
      this.mutationLoading = true;
      const name = "contact " + contact.first_name + " " + contact.last_name;
      this.sendMutation("updated", name, UPDATE_COMPANY_CONTACT, contact)
        .then(() => {
          this.dialog = false;
          this.mutationLoading = false;
        })
        .catch(() => {
          this.mutationLoading = false;
        });
    },
    create(contact) {
      this.mutationLoading = true;
      const name = "contact " + contact.first_name + " " + contact.last_name;
      this.sendMutation("created", name, CREATE_COMPANY_CONTACT, contact)
        .then(() => {
          this.currentCompanyContact = {
            first_name: "",
            last_name: "",
            username: "",
            phones: [],
            emails: [],
            skypes: [],
            company_contact_type: "",
            company_id: "",
          };
          this.dialog = false;
          this.mutationLoading = false;
        })
        .catch(() => {
          this.mutationLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters("companyStore", ["newCompany", "getCompanyContact"]),
    currentCompanyContact() {
      if (this.companyContactId)
        return this.getCompanyContact(this.companyContactId);
      else return this.newCompanyContact;
    },
  },
};
</script>
